import { AbstractControl, ValidationErrors } from '@angular/forms';

export function newPasswordValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  const value = control.value as string;

  const hasUpper = /[A-Z]/.test(value);
  const hasLower = /[a-z]/.test(value);
  const hasNumber = /[0-9]/.test(value);
  const hasSpecial = /[^A-Za-z0-9]/.test(value);
  const hasLength = value.length >= 8;

  const valid = hasUpper && hasLower && hasNumber && hasSpecial && hasLength;

  if (valid) {
    return null;
  } else {
    return {
      invalidPassword: $localize`Invalid password`,
    };
  }
}
